<template>
  <v-bottom-sheet :value="dialog" @input="$emit('update:dialog', $event)" inset persistent content-class="save-changes-sheet">
    <v-card tile dark class="pa-4 text-center">
      <div class="drag-handle-bar mx-auto mb-2"></div>
      <v-card-title class="justify-center font-weight-bold pt-2 pb-2">
        <v-icon left color="primary" large class="mr-2">mdi-content-save-edit</v-icon>
        Trainingsplan anpassen?
      </v-card-title>
      <v-card-subtitle class="pb-3">Wähle aus, welche Änderungen permanent gespeichert werden sollen.</v-card-subtitle>

      <v-divider class="mx-4 mb-4"></v-divider>

      <v-list color="transparent" dense class="mb-4 modified-list">
        <v-list-item v-for="(mod, index) in modifications" :key="index" class="mb-2 list-item-glow" @click="toggleSelection(index)">
          <v-list-item-action class="mr-0">
            <v-checkbox :input-value="selectedModifications.includes(index)" @click.stop="toggleSelection(index)" color="primary"></v-checkbox>
          </v-list-item-action>

          <v-list-item-icon class="mx-3">
            <v-avatar :color="mod.type === 'add' ? 'green' : 'orange'" size="40">
              <v-icon>{{ mod.type === "add" ? "mdi-plus-circle-outline" : "mdi-swap-horizontal-bold" }}</v-icon>
            </v-avatar>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">
              {{ mod.payload.newExercise.title }}
            </v-list-item-title>
            <v-list-item-subtitle class="grey--text text--lighten-1">
              {{ mod.type === "add" ? "Neu hinzugefügt" : `Tausch für: ${mod.payload.originalExercise.title}` }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-row class="mt-4">
        <v-col cols="12">
          <v-btn block x-large depressed color="primary" class="font-weight-bold" @click="saveSelected">
            Auswahl speichern ({{ selectedModifications.length }})
          </v-btn>
        </v-col>
        <v-col cols="12" class="pt-2">
          <v-btn block text color="grey" @click="$emit('discard-changes')"> Keine Änderungen speichern </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
export default {
  name: "SaveChangesDialog",
  props: {
    dialog: { type: Boolean, required: true },
    modifications: { type: Array, default: () => [] },
  },
  data() {
    return {
      // Speichert die INDIZES der ausgewählten Änderungen
      selectedModifications: [],
    }
  },
  computed: {
    areAllSelected: {
      get() {
        return this.modifications.length > 0 && this.selectedModifications.length === this.modifications.length
      },
      set(value) {
        // Dieser Setter wird benötigt, damit v-model funktioniert
      },
    },
  },
  methods: {
    toggleSelectAll() {
      if (this.areAllSelected) {
        this.selectedModifications = []
      } else {
        this.selectedModifications = this.modifications.map((_, index) => index)
      }
    },
    toggleSelection(index) {
      const selectionIndex = this.selectedModifications.indexOf(index)
      if (selectionIndex > -1) {
        this.selectedModifications.splice(selectionIndex, 1)
      } else {
        this.selectedModifications.push(index)
      }
    },
    saveSelected() {
      const actualModifications = this.selectedModifications.map((index) => this.modifications[index])
      this.$emit("save-changes", actualModifications)
    },
  },
  watch: {
    // Wenn der Dialog geöffnet wird, wähle standardmässig alle Änderungen aus
    dialog(newVal) {
      if (newVal) {
        this.selectedModifications = this.modifications.map((_, index) => index)
      }
    },
  },
}
</script>

<style scoped>
.save-changes-sheet {
  background-color: #242424; /* Etwas dunkler für mehr Kontrast */
  border-top-left-radius: 24px !important;
  border-top-right-radius: 24px !important;
  box-shadow: 0 -10px 40px rgba(0, 0, 0, 0.5);
}
.drag-handle-bar {
  width: 40px;
  height: 5px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.select-all-checkbox {
  display: inline-flex;
  background-color: rgba(255, 255, 255, 0.05);
  padding: 0 16px;
  border-radius: 8px;
}
.modified-list .v-list-item {
  background-color: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px !important;
  transition: all 0.2s ease-in-out;
}
.modified-list .v-list-item:hover {
  transform: scale(1.02);
  background-color: rgba(255, 255, 255, 0.08);
}
.list-item-glow {
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
}
</style>
